import { LinkItemErrorsType } from 'modules/stores/store/content/link/types/link-interface'

export const defaultErrors: LinkItemErrorsType = {
  url: '',
  title: '',
  subTitle: '',
  buttonTitle: '',
}
